<template>
  <div class="hand-out">
    <div>
      <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.back()"
        >返回上一级</el-button
      >
    </div>
    <el-divider content-position="left">财税工厂交接出审核列表</el-divider>
    <el-collapse style="border-top: none; margin-bottom: 0.2rem" id="collapse">
      <el-collapse-item>
        <template slot="title">
          <span style="color: #409eff; font-size: medium">筛选</span>
        </template>
        <el-card style="margin-bottom: 0.2rem">
          <el-row :gutter="20">
            <el-col :span="6">
              <span>所属业务</span>:
              <el-cascader
                style="width: 70%"
                v-model="searchArr.business_id"
                placeholder="所属业务"
                :options="typeinerOptions"
                size="medium"
                :props="{ multiple: true, expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                @mousedown.native="loadTypeiner"
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
            <el-col :span="11">
              <span>服务到期时间</span>:
              <!-- <el-date-picker size="medium" v-model="searchArr.service_time" type="daterange" align="right"
                                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd">
                            </el-date-picker> -->
              <el-date-picker
                size="medium"
                style="width: 80%"
                v-model="searchArr.service_time"
                type="monthrange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerOptions"
                value-format="yyyy-MM"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <span>所属财务</span>:
              <el-cascader
                style="width: 70%"
                v-model="searchArr.treasurer_id"
                placeholder="所属财务"
                :options="treasurerOptions"
                size="medium"
                :props="{ multiple: true, expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                @mousedown.native="loadTreasurer"
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 0.2rem">
            <el-col :span="6">
              <span>申请人:&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-cascader
                style="width: 70%"
                v-model="searchArr.opt_name"
                placeholder="申请人"
                :options="optNameOptions"
                size="medium"
                :props="{ multiple: true, expandTrigger: 'hover', emitPath: false }"
                clearable
                filterable
                @mousedown.native="loadOptName"
                :filter-method="filterOptions"
              >
              </el-cascader>
            </el-col>
            <el-col :span="11">
              <span>申请时间:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-date-picker
                size="medium"
                style="width: 80%"
                v-model="searchArr.created_at"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="ysyTypeInPickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <span>已审核:&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-select
                v-model="searchArr.status"
                multiple
                placeholder="请选择"
                clearable
                filterable
                size="medium"
              >
                <el-option label="销售已审核" value="1"> </el-option>
                <el-option label="财务已审核" value="2"> </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top: 0.2rem">
            <el-col :span="6">
              <span>已驳回:&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-select
                v-model="searchArr.refuse"
                multiple
                placeholder="请选择"
                clearable
                filterable
                size="medium"
              >
                <el-option label="销售已驳回" value="1"> </el-option>
                <el-option label="财务已驳回" value="2"> </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
        <div style="text-align: center; margin-top: 0.2rem">
          <el-button type="info" size="medium" @click="HandleReset()">重置</el-button>
          <el-button type="primary" size="medium" @click="HandleQuery()">查询</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入公司名称"
        size="medium"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.company_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="margin-left: auto; display: flex; gap: 0.2rem">
        <!-- <div v-if="hasListPower"> -->
        <div>
          <div
            style="
              margin: auto;
              background-color: #409eff;
              color: aliceblue;
              padding: 11px 20px;
              border-radius: 5px;
            "
          >
            <label style="cursor: pointer">
              <input
                type="checkbox"
                v-model="searchArr.review.sale"
                @change="getWaitToReview"
              />
              <span>销售待审核</span>
            </label>
          </div>
        </div>
        <div>
          <div
            style="
              margin: auto;
              background-color: #409eff;
              color: aliceblue;
              padding: 11px 20px;
              border-radius: 5px;
            "
          >
            <label style="cursor: pointer">
              <input
                type="checkbox"
                v-model="searchArr.review.finance"
                @change="getWaitToReview"
              />
              <span>财务待审核</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="middle-table">
    <el-table
    height="calc(100vh - 356px)"
      :data="tableData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="company_id" label="公司ID" width="80" fixed>
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="公司名称"
        width="260"
        fixed
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="service_status" label="服务状态"> </el-table-column>
      <el-table-column prop="company_status" label="企业状态" width="125">
      </el-table-column>
      <el-table-column prop="fin_charges" label="收费标准"> </el-table-column>
      <el-table-column label="服务时间" width="180">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.service_time.length > 0 && scope.row.service_time.length > 1"
            @click="openServiceTimeDrawer(scope.row.service_time)"
            type="primary"
            >点击查看</el-link
          >
          <el-link
            v-if="
              scope.row.service_time.length > 0 &&
              scope.row.service_time.length === 1 &&
              (scope.row.service_time[0].taxation_service_time.service_started_at ||
                scope.row.service_time[0].taxation_service_time.service_ended_at)
            "
            @click="openServiceTimeDrawer(scope.row.service_time)"
            >{{
              scope.row.service_time[0].taxation_service_time.service_started_at
                ? scope.row.service_time[0].taxation_service_time.service_started_at.substring(
                    0,
                    7
                  )
                : "未知"
            }}
            至
            {{
              scope.row.service_time[0].taxation_service_time.service_ended_at
                ? scope.row.service_time[0].taxation_service_time.service_ended_at.substring(
                    0,
                    7
                  )
                : "未知"
            }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="tax_types" label="纳税人情况" width="100">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.tax_types == 2">小规模</span>
            <span v-else-if="scope.row.tax_types == 3">一般纳税人</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="custody_invoicing" label="托管开票"> </el-table-column>
      <el-table-column
        prop="personnel_matters_custody"
        label="人事托管"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="委托注销">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.unregister == 1">是</span>
            <span v-else-if="scope.row.unregister == 2">否</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="salesman_name" label="所属业务"> </el-table-column>
      <el-table-column prop="treasurer_name" label="所属财务"> </el-table-column>
      <el-table-column prop="notes" label="备注情况" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="out_reason"
        label="申请原因"
        width="180"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="opt_name" label="申请人"> </el-table-column>
      <el-table-column prop="created_at" label="申请时间" width="140">
        <template slot-scope="scope">
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column prop="" label="销售主管审核/时间" width="140">
        <template slot-scope="scope">
          <div style="height: 40px">
            <p>{{ scope.row.reviewer_name_sale }}</p>
            <el-tooltip class="item" effect="dark" content="审核通过时间" placement="top">
              <p>
              <!-- {{ scope.row.reviewered_at_sale }} -->
              <date-formatter :date-value="scope.row.reviewered_at_sale"></date-formatter>
              </p>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="财务主管审核/时间" width="140">
        <template slot-scope="scope">
          <div style="height: 40px">
            <p>{{ scope.row.reviewer_name }}</p>
            <el-tooltip class="item" effect="dark" content="审核通过时间" placement="top">
              <p>
              <!-- {{ scope.row.reviewered_at }} -->
              <date-formatter :date-value="scope.row.reviewered_at"></date-formatter>
              </p>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="驳回原因" width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.refuse_reason ? scope.row.refuse_reason : "---" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="" width="" align="center">
        <template slot="header">
          <span> 审核 </span>
          <el-tooltip
            class="item"
            effect="dark"
            content="由销售先审核,审核通过后财务审核!"
            placement="top"
          >
            <i class="el-icon-info" style="color: #f56c6c"></i>
          </el-tooltip>
        </template>
        <el-table-column label="销售" width="100" align="center">
          <!-- <template slot-scope="scope"> -->
          <!-- <el-switch v-model="ListIfDisplay_sale[scope.row.id]" active-color="#13ce66" inactive-color="#909399"
                            @change="handleSwitchCheckPass_sale($event, scope.$index,scope.row)" :disabled="scope.row.status_sale === 1 ? true : false">
                        </el-switch> -->
          <!-- <el-tooltip class="item" effect="dark" content="设为审核通过(销售主管)" placement="top"
                            v-if="scope.row.status === 2">
                            <el-button type="primary" size="mini" icon="el-icon-question"
                                @click="handleSwitchCheckPass(scope.$index, scope.row)">销售主管</el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="已审核通过(销售主管)" placement="top"
                            v-if="scope.row.status === 1">
                            <el-button type="success" size="mini" icon="el-icon-check" @click="">销售主管</el-button>
                        </el-tooltip> -->
          <!-- </template> -->
          <template slot-scope="scope">
            <div class="examine_btn">
              <el-tooltip
                class="item"
                effect="dark"
                content="通过"
                placement="top"
                v-if="scope.row.status_sale === 2"
              >
                <el-popconfirm
                  title="确认审核通过吗？"
                  @onConfirm="doConfirmSale(scope.$index, scope.row)"
                >
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-check"
                    circle
                    slot="reference"
                  ></el-button>
                </el-popconfirm>
              </el-tooltip>
              <el-tag
                v-if="scope.row.status_sale === 1"
                size="mini"
                effect="dark"
                type="success"
                >已通过</el-tag
              >
            </div>
            <div class="examine_btn" style="margin-left: 0.2rem">
              <el-tooltip
                class="item"
                effect="dark"
                content="驳回"
                placement="top"
                v-if="scope.row.status_sale === 2"
              >
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-close"
                  @click="handleHandoutRefuse_sale(scope.$index, scope.row)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tag
                style="margin-left: -0.5rem"
                v-if="scope.row.status_sale === 3"
                size="mini"
                effect="dark"
                type="danger"
                >已驳回</el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="财务" width="100" align="center">
          <template slot-scope="scope">
            <!-- <el-switch v-model="ListIfDisplay[scope.row.id]" active-color="#13ce66" inactive-color="#909399"
                            @change="handleSwitchCheckPass($event, scope.$index, scope.row)"
                            :disabled="scope.row.status === 1 ? true : false">
                        </el-switch> -->
            <!-- <el-tooltip class="item" effect="dark" content="设为审核通过(财务主管)" placement="top"
                            v-if="scope.row.status === 2">
                            <el-button type="success" size="mini" icon="el-icon-document-checked"
                                @click="handleSwitchCheckPass(scope.$index, scope.row)">财务主管</el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="已审核通过(财务主管)" placement="top"
                            v-if="scope.row.status === 1">
                            <el-button type="success" size="mini" icon="el-icon-check" @click="">财务主管</el-button>
                        </el-tooltip> -->
            <div class="examine_btn">
              <el-tooltip
                class="item"
                effect="dark"
                content="通过"
                placement="top"
                v-if="scope.row.status_sale === 1 && scope.row.status === 2"
              >
                <el-popconfirm
                  title="确认审核通过吗？"
                  @onConfirm="doConfirmFinance(scope.$index, scope.row)"
                >
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-check"
                    circle
                    slot="reference"
                  ></el-button>
                </el-popconfirm>
              </el-tooltip>
              <el-tag
                v-if="scope.row.status === 1"
                size="mini"
                effect="dark"
                type="success"
                >已通过</el-tag
              >
            </div>
            <div class="examine_btn" style="margin-left: 0.2rem">
              <el-tooltip
                class="item"
                effect="dark"
                content="驳回"
                placement="top"
                v-if="scope.row.status_sale === 1 && scope.row.status === 2"
              >
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-close"
                  @click="handleHandoutRefuse_finance(scope.$index, scope.row)"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tag
                style="margin-left: -0.5rem"
                v-if="scope.row.status === 3"
                size="mini"
                effect="dark"
                type="danger"
                >已驳回</el-tag
              >
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    </div>
    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="npage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </div>
    <el-drawer
      title=""
      :visible.sync="ServiceTimeDrawer"
      direction="rtl"
      :before-close="handleCloseServiceTimeDrawer"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">服务时间</span>
      </template>
      <service-time :tyc_order_data="tycOrderData" />
    </el-drawer>
    <el-drawer
      title=""
      :visible.sync="ServiceTimeDrawer"
      direction="rtl"
      :before-close="handleCloseServiceTimeDrawer"
      size="50%"
    >
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem">服务时间</span>
      </template>
      <service-time :tyc_order_data="tycOrderData" />
    </el-drawer>
    <el-dialog
      title="审核驳回"
      :visible.sync="handoutRefuseDialog_sale"
      :modal="true"
      width="30%"
      @close="handleCloseHandoutRefuseDialog_sale"
    >
      <el-form
        :model="handoutRefuseForm"
        :rules="handoutRefuseFormRule"
        ref="handoutRefuseForm"
        label-width="80px"
      >
        <el-form-item label="驳回原因" prop="reason">
          <el-input
            size="medium"
            type="textarea"
            v-model="handoutRefuseForm.reason"
            placeholder=""
            style="white-space: pre"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 0.2rem">
        <el-button
          type="info"
          size="medium"
          @click="HandleResetHandoutRefuseForm('handoutRefuseForm')"
          >清空</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="HandleHandoutRefuseSubmitForm('handoutRefuseForm')"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="审核驳回"
      :visible.sync="handoutRefuseDialog_finance"
      :modal="true"
      width="30%"
      @close="handleCloseHandoutRefuseDialog_finance"
    >
      <el-form
        :model="handoutRefuseForm_finance"
        :rules="handoutRefuseFormRule"
        ref="handoutRefuseForm_finance"
        label-width="80px"
      >
        <el-form-item label="驳回原因" prop="reason">
          <el-input
            size="medium"
            type="textarea"
            v-model="handoutRefuseForm_finance.reason"
            placeholder=""
            style="white-space: pre"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 0.2rem">
        <el-button
          type="info"
          size="medium"
          @click="HandleResetHandoutRefuseForm_finance('handoutRefuseForm_finance')"
          >清空</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="HandleHandoutRefuseSubmitForm_finance('handoutRefuseForm_finance')"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ServiceTime from "./components/ServiceTime";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import DateFormatter from 'common/DateFormatter'
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "HandOut",
  components: { ServiceTime, DateFormatter },
  mixins: [fscDate],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      typeinerOptions: [],
      treasurerOptions: [],
      searchCategories: [],
      optNameOptions: [],
      searchArr: {
        category_id: "",
        business_id: "",
        service_time: "",
        treasurer_id: "",
        opt_name: "",
        created_at: "",
        status: "",
        refuse: "",
        review: {
          sale: false,
          finance: false,
        },
        waitToReviewChange: false,
      },
      searchLoading: false,
      tableData: [],
      ListIfDisplay: [],
      ListIfDisplay_sale: [],
      ServiceTimeDrawer: false,
      tycOrderData: [],
      pageSize: 30,
      total: 0,
      npage: 1,
      hand_out_id: null,
      hand_out_data_index: null,
      handoutRefuseDialog_sale: false,
      handoutRefuseForm: {
        reason: "",
      },
      handoutRefuseDialog_finance: false,
      handoutRefuseForm_finance: {
        reason: "",
      },
      handoutRefuseFormRule: {
        reason: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
          { min: 1, max: 255, message: "填写过长", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    loadTable() {
      this.$axios
        .get("api/api3_finance_taxation_hand_out_list", {
          params: {
            page: this.npage,
            perPage: this.pageSize,
            searchItem: this.searchArr,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.searchArr.waitToReviewChange = false;
            this.tableData = data.data.data;
            this.total = data.data.total;
            if (data.config) {
              this.searchArr.review.sale = data.config.review_sale === 1 ? true : false;
              this.searchArr.review.finance =
                data.config.review_finance === 1 ? true : false;
            }
          }
        })
        .catch();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.npage = 1;
      this.pageSize = val;
      this.loadTable();
    },
    handleCurrentChange(val) {
      this.npage = val;
      this.loadTable();
    },
    handleCloseServiceTimeDrawer(done) {
      // this.$confirm('确认关闭？')
      //   .then((_) => {
      this.tycOrderData = [];
      done();
      //   })
      //   .catch((_) => {})
    },
    handleSwitchCheckPass(e, index, row) {
      this.$axios
        .put("api/api3_finance_taxation_hand_out_checked_pass", {
          id: row.id,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.tableData[index]["status"] = 1;
            this.loadTable();
            this.$message.success(data.msg);
          } else {
            this.$set(this.ListIfDisplay, row.id, false);
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleSwitchCheckPass_sale(index, row) {
      this.$axios
        .put("api/api3_finance_taxation_hand_out_checked_pass_sale", {
          id: row.id,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.tableData[index]["status_sale"] = 1;
            this.loadTable();
            this.$message.success(data.msg);
          } else {
            // this.$set(this.ListIfDisplay_sale, row.id, false);
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    openServiceTimeDrawer(data) {
      this.ServiceTimeDrawer = true;
      this.$nextTick((_) => {
        this.tycOrderData = data;
      });
    },
    doConfirmSale(index, row) {
      this.handleSwitchCheckPass_sale(index, row);
    },
    handleHandoutRefuse_sale(index, row) {
      this.$axios
        .get("api/api3_finance_taxation_get_handover_out_review_power_sale")
        .then(({ data }) => {
          if (data.code === 200) {
            this.hand_out_id = row.id;
            this.hand_out_data_index = index;
            this.handoutRefuseDialog_sale = true;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleCloseHandoutRefuseDialog_sale() {
      this.HandleResetHandoutRefuseForm();
      this.hand_out_data_index = null;
      this.hand_out_id = null;
    },
    HandleResetHandoutRefuseForm() {
      this.handoutRefuseForm = this.$options.data().handoutRefuseForm;
    },
    HandleHandoutRefuseSubmitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handoutRefuseForm.id = this.hand_out_id;
          this.$axios
            .post(
              "api/api3_finance_taxation_get_handover_out_review_refuse",
              this.handoutRefuseForm
            )
            .then(({ data }) => {
              if (data.code === 200) {
                this.tableData[
                  this.hand_out_data_index
                ].refuse_reason = this.handoutRefuseForm.reason;
                this.tableData[this.hand_out_data_index].reviewer_name_sale =
                  data.data["reviewer_name_sale"];
                this.tableData[this.hand_out_data_index].reviewered_at_sale =
                  data.data["reviewered_at_sale"];
                this.tableData[this.hand_out_data_index].status_sale = 3;
                this.handleCloseHandoutRefuseDialog_sale();
                this.handoutRefuseDialog_sale = false;
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    doConfirmFinance(index, row) {
      this.handleSwitchCheckPass_finance(index, row);
    },
    handleSwitchCheckPass_finance(index, row) {
      this.$axios
        .put("api/api3_finance_taxation_hand_out_checked_pass", {
          id: row.id,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.tableData[index]["status"] = 1;
            this.loadTable();
            this.$message.success(data.msg);
          } else {
            // this.$set(this.ListIfDisplay, row.id, false);
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleHandoutRefuse_finance(index, row) {
      this.$axios
        .get("api/api3_finance_taxation_get_handover_out_review_power_finance")
        .then(({ data }) => {
          if (data.code === 200) {
            this.hand_out_id = row.id;
            this.hand_out_data_index = index;
            this.handoutRefuseDialog_finance = true;
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    handleCloseHandoutRefuseDialog_finance() {
      this.HandleResetHandoutRefuseForm_finance();
      this.hand_out_data_index = null;
      this.hand_out_id = null;
    },
    HandleResetHandoutRefuseForm_finance() {
      this.handoutRefuseForm_finance = this.$options.data().handoutRefuseForm_finance;
    },
    HandleHandoutRefuseSubmitForm_finance(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handoutRefuseForm_finance.id = this.hand_out_id;
          this.$axios
            .post(
              "api/api3_finance_taxation_get_handover_out_review_refuse_finance",
              this.handoutRefuseForm_finance
            )
            .then(({ data }) => {
              if (data.code === 200) {
                this.tableData[
                  this.hand_out_data_index
                ].refuse_reason = this.handoutRefuseForm_finance.reason;
                this.tableData[this.hand_out_data_index].reviewer_name =
                  data.data["reviewer_name"];
                this.tableData[this.hand_out_data_index].reviewered_at =
                  data.data["reviewered_at"];
                this.tableData[this.hand_out_data_index].status = 3;
                this.handleCloseHandoutRefuseDialog_finance();
                this.handoutRefuseDialog_finance = false;
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch();
        } else {
          return false;
        }
      });
    },
    searchRemoteCfcategory(query) {
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchItem(query);
        }, 200);
      } else {
        this.searchCategories = [];
      }
    },
    searchItem(query) {
      this.$axios
        .get("api/api3_finance_taxation_remote_search_company", {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.searchCategories = data.data;
          }
        })
        .catch();
    },
    handleSearchCfcategory(query) {
      // this.searcher = query
      this.loadTable();
    },
    loadTypeiner() {
      setTimeout(() => {
        this.$axios
          .get("api/admin/user/branch")
          .then(({ data }) => {
            if (data.code === 1) {
              this.typeinerOptions = data.data;
              this.typeinerOptions.unshift({
                value: "n",
                label: "没有业务员的",
              });
            }
          })
          .catch();
      }, 200);
    },
    loadOptName() {
      setTimeout(() => {
        this.$axios
          .get("api/admin/user/branch")
          .then(({ data }) => {
            if (data.code === 1) {
              this.optNameOptions = data.data;
            }
          })
          .catch();
      }, 200);
    },
    loadTreasurer() {
      setTimeout(() => {
        this.$axios
          .get("api/admin/user/branch")
          .then(({ data }) => {
            if (data.code === 1) {
              this.treasurerOptions = data.data;
              this.treasurerOptions.unshift({
                value: "n",
                label: "没有所属财务的",
              });
            }
          })
          .catch();
      }, 200);
    },
    HandleReset() {
      this.searchArr.business_id = "";
      this.searchArr.service_time = "";
      this.searchArr.treasurer_id = "";
      this.searchArr.opt_name = "";
      this.searchArr.created_at = "";
      this.searchArr.status = "";
      this.searchArr.refuse = "";
    },
    HandleQuery() {
      this.npage = 1;
      this.loadTable();
    },
    getWaitToReview() {
      this.searchArr.waitToReviewChange = true;
      this.npage = 1;
      this.loadTable();
    },
  },
  watch: {
    tableData(n) {
      n.forEach((item) => {
        if (item.status === 1) {
          this.ListIfDisplay[item.id] = true;
        } else {
          this.ListIfDisplay[item.id] = false;
        }
        if (item.status_sale === 1) {
          this.ListIfDisplay_sale[item.id] = true;
        } else {
          this.ListIfDisplay_sale[item.id] = false;
        }
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>

<style scoped>
.hand-out {
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.hand-out >>> .el-collapse-item__wrap {
  position: fixed;
  width: -webkit-fill-available;
  z-index: 222 !important;
}

.middle-table{
    z-index: 1;
  }

.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}

.middle-table {
  z-index: 1;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.examine_btn {
  display: inline-block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/financeTaxation/HandOut.vue